<template>
  <v-dialog v-model="moveDialog.open" max-width="520">
    <v-card>
      <v-card-title class="text-h6">
        {{ $t(moveDialog.title) }}
      </v-card-title>

      <v-card-text>
        <p v-if="moveDialog.description">{{ moveDialog.description }}</p>

        <v-form ref="form" lazy-validation>
          <v-select :items="array" item-text="name" item-value="id" v-model="localTargetId"
            :label="$t('general.selectDestination')" :disabled="loading"
            :rules="[v => !!v || $t('general.fieldRequired')]" data-cy="move-destination" />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('cancel')" :disabled="loading" data-cy="move-cancel">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="primary" :loading="loading" :disabled="!localTargetId || loading" @click="onConfirm"
          data-cy="move-confirm">
          {{ $t('general.move') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "moveDialog",
  props: {
    item: { type: Object, required: true },
    moveDialog: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    array: { type: Array, required: true }
  },
  data: () => ({
    localTargetId: null,
  }),
  watch: {
    "moveDialog.open"(val) {
      if (val) this.localTargetId = null;
    },
  },
  methods: {
    async onConfirm() {
      if (!this.localTargetId) return;
      this.$emit('confirm', this.localTargetId);
    },
  },
};
</script>
